function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import React, { Component } from "react";
import { PropTypes } from "prop-types";
import noop from "lodash/noop";
import { CheckedProvider } from "../Context.js";
var SingleSelectGroup = /*#__PURE__*/function (_Component) {
  _inherits(SingleSelectGroup, _Component);
  var _super = _createSuper(SingleSelectGroup);
  function SingleSelectGroup() {
    var _this;
    _classCallCheck(this, SingleSelectGroup);
    _this = _super.apply(this, arguments);
    _defineProperty(_assertThisInitialized(_this), "handleValueChange", function (evt) {
      var _this$props = _this.props,
        onValueChange = _this$props.onValueChange,
        onChange = _this$props.onChange;
      onValueChange(evt.target.value, evt);
      onChange(evt);
    });
    return _this;
  }
  _createClass(SingleSelectGroup, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        value = _this$props2.value;
      return /*#__PURE__*/React.createElement(CheckedProvider, {
        value: {
          onChange: this.handleValueChange,
          isChecked: function isChecked(childValue) {
            return childValue === value;
          }
        }
      }, children);
    }
  }]);
  return SingleSelectGroup;
}(Component);
_defineProperty(SingleSelectGroup, "defaultProps", {
  value: '',
  onChange: noop,
  onValueChange: noop
});
process.env.NODE_ENV !== "production" ? SingleSelectGroup.propTypes = {
  /**
   * One to many RadioButton components.
   */
  children: PropTypes.node,
  /**
   * The currently selected value.
   */
  value: PropTypes.string,
  /**
   * Callback for when user selects a value. Prefer to use `onValueChange`
   *
   * ```ts
   * type onChange = (evt: React.SyntheticEvent): void
   * ```
   */
  onChange: PropTypes.func,
  /**
   * Callback called when user selects a value. The `value` argument is the new value selected.
   *
   * ```ts
   * type onValueChange = (value: string, evt: React.SyntheticEvent): void
   * ```
   */
  onValueChange: PropTypes.func
} : void 0;
export default SingleSelectGroup;